import React from 'react';
import { MdFacebook } from 'react-icons/md';

interface ConnectSectionProps {
  integrationName: string;
  integrationType: string;
  isActivating: boolean;
  loading: boolean;
  emailFromName: string;
  onEmailFromNameChange: (value: string) => void;
  onConnect: () => void;
  onInstagramFacebookConnect: () => void;
  onInstagramDirectConnect: () => void;
}

const ConnectSection: React.FC<ConnectSectionProps> = ({
  integrationName,
  integrationType,
  isActivating,
  loading,
  emailFromName,
  onEmailFromNameChange,
  onConnect,
  onInstagramFacebookConnect,
  onInstagramDirectConnect,
}) => {
  const type = integrationType.toLowerCase();

  return (
    <div className="">
      <div className="text-center max-w-md mx-auto">
        <h2 className="text-white text-2xl font-semibold mb-3">Connect {integrationName}</h2>
        <p className="text-gray-400 text-sm mb-8 leading-relaxed">
          Connect your {integrationName} account to automatically sync and share your campaigns across your{' '}
          {integrationName} page and business account.
        </p>

        {type === 'instagram' ? (
          <div className="space-y-4">
            <button
              onClick={onInstagramFacebookConnect}
              disabled={isActivating || loading}
              className="w-full py-4 rounded-xl font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-[#1877F2] hover:bg-[#0c63d4] text-white shadow-lg flex items-center justify-center gap-3"
            >
              <MdFacebook size={24} />
              <span>{isActivating ? 'Connecting...' : 'Continue with Facebook'}</span>
            </button>

            <div className="flex items-center gap-4">
              <div className="flex-1 h-px bg-gray-600"></div>
              <span className="text-gray-400 text-sm font-medium">OR</span>
              <div className="flex-1 h-px bg-gray-600"></div>
            </div>

            <button
              onClick={onInstagramDirectConnect}
              disabled={isActivating || loading}
              className="w-full py-4 rounded-xl font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-gradient-to-r from-[#833AB4] via-[#E4405F] to-[#F77737] hover:opacity-90 text-white shadow-lg"
            >
              {isActivating ? 'Connecting...' : 'Login with Instagram'}
            </button>
          </div>
        ) : type === 'email' ? (
          <div className="space-y-4">
            <div>
              <label htmlFor="fromName" className="block text-gray-300 text-sm font-medium mb-2 text-left">
                From Name <span className="text-red-500">*</span>
              </label>
              <input
                id="fromName"
                type="text"
                value={emailFromName}
                onChange={(e) => onEmailFromNameChange(e.target.value)}
                placeholder="Enter sender name"
                className="w-full px-4 py-3 rounded-xl bg-[#2a2a2a] border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:border-brand-primary transition-colors"
              />
              <p className="text-gray-400 text-xs mt-2 text-left">
                This name will appear as the sender in your emails
              </p>
            </div>
            <button
              onClick={onConnect}
              disabled={isActivating || loading || !emailFromName.trim()}
              className="w-full py-4 rounded-xl font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-brand-primary hover:bg-[#ee4423] text-white shadow-lg"
            >
              {isActivating ? 'Connecting...' : `Connect ${integrationName}`}
            </button>
          </div>
        ): type === 'sms' ? (
          <div className="space-y-4">
            <div>
              {/* <label htmlFor="fromName" className="block text-gray-300 text-sm font-medium mb-2 text-left">
                From Name <span className="text-red-500">*</span>
              </label> */}
              {/* <input id="fromName" type="text" value={emailFromName}
                onChange={(e) => onEmailFromNameChange(e.target.value)}
                placeholder="Enter sender name"
                className="w-full px-4 py-3 rounded-xl bg-[#2a2a2a] border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:border-brand-primary transition-colors"
              /> */}
              {/* <p className="text-gray-400 text-xs mt-2 text-left">
                This name will appear as the sender in your sms
              </p> */}
            </div>

            <button
              onClick={onConnect}
              // disabled={isActivating || loading || !emailFromName.trim()}
              className="w-full py-4 rounded-xl font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-brand-primary hover:bg-[#ee4423] text-white shadow-lg"
            >
              connect sms
            </button>
          </div>
        ) : (
          <button
            onClick={onConnect}
            disabled={isActivating || loading}
            className="w-full py-4 rounded-xl font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-brand-primary hover:bg-[#ee4423] text-white shadow-lg"
          >
            {isActivating ? 'Connecting...' : `Connect ${integrationName}`}
          </button>
        )}
      </div>
    </div>
  );
};

export default ConnectSection;
